import { z } from 'zod';

// Bulk close: chiude in transaction atomica una lista di documenti dello stesso tipo.
// Solo PSC e LNP sono supportati in questa iter (replica chiudiDocumentiSelezionati Drive).
export const bulkCloseTypeSchema = z.enum(['PSC', 'LNP']);
export type BulkCloseType = z.infer<typeof bulkCloseTypeSchema>;

export const bulkCloseRequestSchema = z.object({
  type: bulkCloseTypeSchema,
  ids: z.array(z.string().uuid()).min(1).max(50),
});
export type BulkCloseRequest = z.infer<typeof bulkCloseRequestSchema>;

export const bulkCloseErrorSchema = z.object({
  id: z.string(),
  reason: z.string(),
});

export const bulkCloseResponseSchema = z.object({
  closed: z.number().int().nonnegative(),
  errors: z.array(bulkCloseErrorSchema),
  closedIds: z.array(z.string()),
});
export type BulkCloseResponse = z.infer<typeof bulkCloseResponseSchema>;
